import { RA$ } from '@infl-ts/util-fp-ts';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import CheckBoxGroupFormField from '../../checkbox-group-form-field';
import { decodeHtmlEntities } from '../utils/decode-html-entities';
import { jsx as _jsx } from "react/jsx-runtime";

var CheckboxInput = function CheckboxInput(_ref) {
  var name = _ref.name,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      options = _ref.options,
      _ref$questionForm = _ref.questionForm,
      control = _ref$questionForm.control,
      getValues = _ref$questionForm.getValues,
      setValue = _ref$questionForm.setValue,
      clearErrors = _ref$questionForm.clearErrors,
      errors = _ref$questionForm.formState.errors;
  return pipe(getValues(name), function (val) {
    return RA$.isArray(val) ? O.some(val) : O.none;
  }, O.match(function () {
    //TODO(qlonik): Replace with LogRocket logging
    console.error('Checkbox Question requires an array of options');
    return null;
  }, function (selectedOptions) {
    return /*#__PURE__*/_jsx(CheckBoxGroupFormField, {
      control: control,
      name: name,
      required: required,
      options: options.map(function (o) {
        return {
          label: decodeHtmlEntities(o.description),
          value: o.description
        };
      }),
      selectedOptions: selectedOptions,
      setChecked: function setChecked(checkedVals) {
        return setValue(name, checkedVals);
      },
      errors: !!errors[name],
      handleErrorClear: function handleErrorClear() {
        return clearErrors(name);
      }
    });
  }));
};

export default CheckboxInput;